import styled from 'styled-components';
import { device } from '../../../../ui-components/breakpoints';
import { regularWhite } from '../../../../ui-components/design-tokens';
import { PlayContainer } from '../../../../ui-components/PlayContainer/PlayContainer.styles';
import { playFocus } from '../../../../ui-components/utils.styles';

export const Genres = styled(PlayContainer)`
    padding: 15px 0;

    @media ${device.GteSmall} {
        padding: 25px 0;
    }

    @media ${device.GteMedium} {
        padding: 45px 0;
    }
`;

export const GenresList = styled.nav`
    display: flex;
    flex-direction: column;
`;

export const GenreListRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
`;

export const GenresListElement = styled.div`
    margin-bottom: 15px;
    width: 50%;

    @media ${device.GteSmall} {
        width: 25%;
    }
`;

export const GenreLink = styled.a`
    ${playFocus()}
    color: ${regularWhite};
    text-decoration: none;
    &:hover,
    &:active,
    &:focus {
        text-decoration: underline;
    }
`;
